export interface Standalone {
  standalone: boolean;
}

export class StandaloneService {
  public static isStandalone(customFormControl: unknown): customFormControl is Standalone {
    return (customFormControl as Standalone).standalone !== undefined;
  }
}
